import { useParams } from 'react-router-dom';
import { useCollection } from '../hooks/useCollection';
import UserProgramList from '../lists/UserProgramList';
import ProgramList from '../lists/ProgramList';
import { useSelector, useDispatch } from 'react-redux';
import { setEmailId } from '../context/userSlice';
import { setCurrentUser } from '../context/userSlice';
import AllVideosList from '../lists/AllVideosList';
import { Tab, Tabs } from 'react-bootstrap';
import React, { useState } from 'react';
import InputModal from '../components/InputModal';
import NewUserExerciseForm from '../components/NewUserExerciseForm';
import NewUserProgramForm from '../components/NewUserProgramForm';
import { useUserProgramActions } from '../hooks/useUserProgramActions'
import VideoPlayerDialog from '../components/VideoPlayerDialog';
import IconButton from "@mui/material/IconButton";
import AddIcon from '@mui/icons-material/Add';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { Tooltip } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import PieChartIcon from '@mui/icons-material/PieChart';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import UserReports from '../components/UserReports';
import TrainingDiary from '../components/TrainingDiary';
import RunCircleIcon from '@mui/icons-material/RunCircle';
import EditIcon from '@mui/icons-material/Edit';
import UpdateUserForm from '../components/UpdateUserForm';
import { useAdminActions } from '../hooks/useAdminActions';
import SearchInput from '../components/SearchInput';
import { setCopiedExercise } from '../context/copiedExerciseSlice';
import SendIcon from '@mui/icons-material/Send';
import SendMessageForm from '../components/SendMessageForm';

export default function Userdetail({ handleChangeAppbarTitle }) {
    let { id } = useParams();
    const { data: users } = useCollection('/Users')
    const dispatch = useDispatch();
    const [showNewExerciseModal, setShowNewExerciseModal] = useState(false)
    const [showEditExerciseModal, setShowEditExerciseModal] = useState(false)

    const [showNewProgramModal, setShowNewProgramModal] = useState(false)
    const [showUpdateUserModal, setShowUpdateUserModal] = useState(false)
    const [showSendMessageModal, setShowSendMessageModal] = useState(false)

    const [showDiary, setShowDiary] = useState(false)
    const [showReports, setShowReports] = useState(false)
    const [showExercises, setShowExercises] = useState(true)

    const [showVideoPlayer, setShowVideoPlayer] = useState(false)
    const [exerciseId, setExerciseId] = useState('')
    const [videoTitle, setVideoTitle] = useState('')
    const [visibleDelete, setVisibleDelete] = useState(null);
    const [existingItem, setExistingItem] = useState(null)

    const { newUserExercise, editUserExercise, pasteUserExercise } = useUserProgramActions()
    const { updateUser } = useAdminActions()
    const [searchString, setSearchString] = useState('')
    const [userProgSearchString, setUserProgSearchString] = useState('')

    const companyId = useSelector((state) => state.company.id);
    const copiedExercise = useSelector((state) => state.copiedExercise.exercise);
    const userPrograms = useSelector((state) => state.userProgram.userProgram)

    if ((id === null || id === undefined) && users != null) {
        let filteredUsers = users && users.filter(u => u.companyid === companyId)
        if (filteredUsers.length > 0) {
            id = filteredUsers[0].id
        }
    }

    const userDetails = users && users.filter(u => u.id === id)
    const userDetail = userDetails ? userDetails[0] : null

    let emailId = 'na'
    if (userDetail && userDetail.email) {
        emailId = userDetail.email.replaceAll(".", "")
        dispatch(setEmailId(emailId))
        dispatch(setCurrentUser(userDetail))
        handleChangeAppbarTitle("Brukerprogram - " + userDetail.name)

    }

    const [activeTab, setActiveTab] = useState('tab1');

    const handleTabSelect = (eventKey) => {
        setActiveTab(eventKey);
    };

    const handleCloseModal = () => {
        setShowNewExerciseModal(false)
        setShowVideoPlayer(false)
        setShowNewProgramModal(false)
        setShowUpdateUserModal(false)
        setShowEditExerciseModal(false)
        setShowSendMessageModal(false)
    }

    const handleShowNewExerciseModal = () => {
        setShowNewExerciseModal(true)
    }

    const handleShowNewProgramModal = () => {
        setShowNewProgramModal(true)
    }

    const handleAddUserProgram = (exercise) => {
        newUserExercise(exercise)
        setShowNewProgramModal(false)
        setShowNewExerciseModal(false)
    }

    const handleEditUserProgram = (exercise) => {
        editUserExercise(exercise)
        setShowNewProgramModal(false)
        setShowEditExerciseModal(false)
    }

    const onContextMenuClick = (node, action) => {
        if (action === 0) {
            handleShowVideoExercise(node)
        } else if (action === 1) {
            handleEditItem(node)
        } else if (action === 2) {
            handleCopyItem(node)
        } else if (action === 3) {
            handlePasteItem(node)
        }
    }

    const handleShowVideoExercise = (node) => {
        setExerciseId(node.id)
        setShowVideoPlayer(true)
    }

    const handleEditItem = (node) => {
        setExistingItem(node)
        setShowEditExerciseModal(true)
    }

    const handleCopyItem = (node) => {
        const foundExercise = userPrograms.find(p => p.id === node.id)
        if (foundExercise) {
            dispatch(setCopiedExercise(foundExercise))
        }
    }

    const handlePasteItem = (node) => {
        pasteUserExercise(copiedExercise, node.id)
    }

    const handleSetTitle = (title) => {
        setVideoTitle(title)
    }

    const handleClick = () => {
        setVisibleDelete(!visibleDelete)
    }

    const handleShowDiary = () => {
        setShowDiary(true)
        setShowReports(false)
        setShowExercises(false)
    }

    const handleShowReports = () => {
        setShowReports(true)
        setShowExercises(false)
        setShowDiary(false)
    }

    const handleShowExercises = () => {
        setShowExercises(true)
        setShowDiary(false)
        setShowReports(false)
    }

    const handleShowUpdateUser = () => {
        setShowUpdateUserModal(true)
    }

    const handleUpdateUser = (userDetail) => {
        updateUser(userDetail)
        setShowUpdateUserModal(false)
    }

    const handleSearchString = (searchString) => {
        setSearchString(searchString)
    }

    const handleuserProgSearchString = (searchString) => {
        setUserProgSearchString(searchString)
    }
    const handleSendMessage = () => {
        setShowSendMessageModal(true)
    }
    const handleCloseSendMessageForm= () => {
        setShowSendMessageModal(false)
    }

    return (
        <div className='user-details' >
            <div className='p-2 flex-grow-1 dig-container-bottommargin'
                style={{
                    textAlign: 'left',
                }}
            >
                <span style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingLeft: 20,
                    paddingRight: 20
                }}>
                    <h2 style={{ color: 'gray', marginTop: 10 }}>{userDetail && userDetail.name}</h2>
                    <span>
                        <Tooltip title="Vis øvelser">
                            <IconButton onClick={handleShowExercises} color="primary">
                                <RunCircleIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Vis treningsdagbok">
                            <IconButton onClick={handleShowDiary} color="primary">
                                <FactCheckIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Vis statistikk">
                            <IconButton onClick={handleShowReports} color="primary">
                                <PieChartIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Rediger bruker">
                            <IconButton onClick={handleShowUpdateUser} color="primary">
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Send melding">
                            <IconButton onClick={handleSendMessage} color="primary">
                                <SendIcon />
                            </IconButton>
                        </Tooltip>
                    </span>
                </span>
                <div style={{ color: 'GrayText', fontSize: 'smaller', lineHeight: '0.5em' }}>
                    <ul>Email: {userDetail && userDetail.email}</ul>
                    <ul>Versjon: {userDetail && userDetail.devicetype}</ul>
                </div>
            </div>
            {showReports && !showExercises && !showDiary &&
                <div className='dig-container-bottommargin'>
                    <UserReports />
                </div>
            }
            {showDiary && !showReports && !showExercises &&
                <div className='dig-container-bottommargin'>
                    <TrainingDiary />
                </div>
            }
            {!showReports && !showDiary && showExercises && <div className='d-flex'>
                <div className='p-2 flex-grow-1 dig-container-leftmargin'>
                    <SearchInput handleSearchString={handleuserProgSearchString} setMargin={15}>
                        <span className="p-1 flex-grow-1"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}>
                            <h5 style={{ color: 'gray', margin: 20 }}>Øvelser</h5>
                            <div style={{
                                margin: 10
                            }}>
                                <Tooltip title="Legg til nytt program">
                                    <IconButton onClick={handleShowNewProgramModal} color="primary" >
                                        <CreateNewFolderIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Legg til ny øvelse">
                                    <IconButton onClick={handleShowNewExerciseModal} color="primary">
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Slettemodus av/på">
                                    <IconButton onClick={handleClick} color="primary">
                                        <ClearIcon />
                                    </IconButton>
                                </Tooltip>

                            </div>
                        </span>
                    </SearchInput>

                    <div className="userprogram-list">
                        <UserProgramList
                            handleShowNewExerciseModal={handleShowNewExerciseModal}
                            handleShowNewProgramModal={handleShowNewProgramModal}
                            onContextMenuClick={onContextMenuClick}
                            visibleDelete={visibleDelete}
                            showEditMenu={true}
                            searchString={userProgSearchString}
                        />
                    </div>



                </div>
                <div className='p-2 flex-grow-1 dig-container'>
                    <SearchInput handleSearchString={handleSearchString}>

                        <Tabs activeKey={activeTab} onSelect={handleTabSelect}>
                            <Tab eventKey="tab1" title="Programmer" style={{ marginBottom: 20 }} />
                            <Tab eventKey="tab2" title="Alle videoer" style={{ marginBottom: 20 }} />
                        </Tabs>
                    </SearchInput>

                    <div>
                        {activeTab === 'tab1' && (
                            <div className="userprogram-list">
                                <ProgramList
                                    onContextMenuClick={onContextMenuClick}
                                    searchString={searchString}

                                />
                            </div>
                        )}
                        {activeTab === 'tab2' && (
                            <div className="userprogram-list">
                                <AllVideosList
                                    onContextMenuClick={onContextMenuClick}
                                    searchString={searchString}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>}
            {showUpdateUserModal &&
                (<InputModal title="Rediger bruker" handleCloseModal={handleCloseModal}>
                    <UpdateUserForm updateUser={handleUpdateUser} userDetail={userDetail} />
                </InputModal>)
            }
            {showNewExerciseModal &&
                (<InputModal title="Legg til ny øvelse" handleCloseModal={handleCloseModal}>
                    <NewUserExerciseForm addUserProgram={handleAddUserProgram} />
                </InputModal>)
            }
            {showEditExerciseModal &&
                (<InputModal title="Rediger øvelse" handleCloseModal={handleCloseModal}>
                    <NewUserExerciseForm addUserProgram={handleEditUserProgram} existingItem={existingItem} />
                </InputModal>)
            }
            {showNewProgramModal &&
                (<InputModal title="Legg til nytt program" handleCloseModal={handleCloseModal}>
                    <NewUserProgramForm addUserProgram={handleAddUserProgram} />
                </InputModal>)
            }
            {showVideoPlayer &&
                (<InputModal title={videoTitle} handleCloseModal={handleCloseModal}>
                    <VideoPlayerDialog exerciseId={exerciseId} handleSetTitle={handleSetTitle} />
                </InputModal>)
            }
            {showSendMessageModal &&
                (<InputModal title="Send melding" handleCloseModal={handleCloseModal}>
                    <SendMessageForm usertoken={userDetail.usertoken} handleCloseSendMessageForm={handleCloseSendMessageForm}/>
                </InputModal>)
            }
        </div>
    )
}
